import CarouselStyle from './carouselStyle';

import {
  titleMedium,
  haylardDisplay,
  haylardDisplayBold,
  cormorantGaramond,
  garamond
} from "../../style/style.jsx";

import colors from "../../style/colors.scss";

const GalleryCarouselStyle = theme => ({
    ...CarouselStyle(theme),
    sliderContent: {
      border: 'none',
      outline: 'none'
    },
    sliderContentFixedWidth: {
      border: 'none',
      outline: 'none',
      "width": "325px",
      [theme.breakpoints.up('md')] : {
        "width":"100%",
        "height": "100%",
    }
    },
    sliderContentPlan: {
      border: 'none',
      outline: 'none',
      paddingLeft: '5px',
      paddingRight: '5px'
    },
    sliderContentCard: {
      height: '650px',
      [theme.breakpoints.down('sm')] : {
        height: '300px'
      }
    },
    sliderContentCardFullInfo: {
      height: '800px',
      [theme.breakpoints.down('sm')] : {
        height: 'auto',
        "border": "1px solid #353535",
      }
    },
    sliderContentCardPlan: {
      height: '650px',
      border: '1px solid black',
      padding: '50px 100px',
      [theme.breakpoints.down('sm')] : {
        height: '400px',
        padding: '20px'
      }
    },
    customDots: {
      width: "10px",
      height: "10px",
      backgroundColor: 'rgba(255,255,255,0.7)',
      boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.45)",
      position: 'relative',
      bottom:'5px',
    },
    activeDots:{
      width: "10px",
      height: "10px",
      backgroundColor: 'white',
      boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.45)",
      position: 'relative',
      bottom:'5px',
    },  
    comingSoonTitle: {
      ...titleMedium,
      color: 'white',
      backgroundColor: colors.darkGrey,
      height: '50px',
      [theme.breakpoints.down('sm')] : {
        fontSize: '20px',
        textAlign: 'center'
      }
    },
    comingSoonTitleHidden: {
      height: '50px'
    },
    planProjectSingleCard: {
      width: '60%',
      [theme.breakpoints.down('sm')] : {
        width: '100%',
        padding: '10px'
      }
    },
    planImgContainer: {
      height: '85%', 
      [theme.breakpoints.down('sm')] : {
        maxHeight: '300px'
      }
    },
    descriptionContainerMobile: {
      "display": "none",
      [theme.breakpoints.down('sm')] : {
        "display":"block",
        "margin-top": "20px",
        "margin-bottom": "80px"
      }
    },
    descriptionContainer: {
      "position": "absolute",
      "bottom": "30px",
      "left": "30px",
      "color": "white",
      "text-align": "left",
      [theme.breakpoints.down('sm')] : {
        "display":"none",
      }
    },
    FIContainer: {
      "marginLeft": "100px",
      "color": "white",
      "max-width": "30%",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "flex-direction": "column",
      "text-align": "center",
    },
    smallHr: {
      height: "1px",
      "color": "white",
      "width": "30px",
      "margin": "0",
      "background": "white",
      "margin-top": "25px"
    },
    darkOverlay: {
      display: 'flex',
      "background-color": "rgba(0,0,0,0.2)",
      "width": "100%",
      height: '650px',
      [theme.breakpoints.down('md')] : {
          height: '500px',
      },
      [theme.breakpoints.down('sm')] : {
        "display":"none"
      }
    },
    visibleSM: {
      [theme.breakpoints.up('sm')]: {
        "display":"none"
      }
    },
    SMDescription: {
      "padding-top":"20px",
      width: "100%",
      height: "300px",
      "display":"flex",
      "align-items":"center",
      "flex-direction":"column",
    },
    galleryDescription: {
      position: "relative",
      [theme.breakpoints.down('sm')]: {
        "position":"unset",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }
    },
    galleryDescriptionFixedHeight: {
      position: "relative",
      [theme.breakpoints.down('sm')]: {
        "position":"unset",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        "height": "325px"
      }
    },
    galleryBottomTitle: {
      ...haylardDisplayBold,
      "font-size": "20px",
      "line-height": "20px",
      "color": "white",
      textTransform: 'uppercase',
      [theme.breakpoints.down('sm')] : {
        "font-size": "15px",
        "line-height": "15px",
        "color": "black",
      }
    },
    galleryBottomSubtitle: {
      ...haylardDisplay,
      "font-size": "20px",
      "color": "white",
      [theme.breakpoints.down('sm')] : {
        "font-size": "15px",
        "line-height": "15px",
        "color": "black",
      }
    },
    galleryFITitle: {
      ...cormorantGaramond,
      "font-style": "italic",
      "font-size": "20px",
      "line-height": "15px",
      [theme.breakpoints.down('sm')] : {
        "font-size": "20px",
      }
    },
    galleryFISubtitle: {
      ...haylardDisplay,
      "font-size": "32px",
      "margin-top": "20px",
      [theme.breakpoints.down('sm')] : {
        "margin-top": "10px",
        "font-size": "30px",
      }
    },
    galleryFIDescription: {
      ...garamond,
      "font-size": "16px",
      "line-height": "30px",
      "margin-top": "20px",
      [theme.breakpoints.down('sm')] : {
        "margin-top": "10px",
        "font-size": "20px",
        "max-width": "70%",
        "letter-spacing":"unset",
        "text-align":"center"
      }
    }
});

export default GalleryCarouselStyle;